<template>
    <!-- flv 视频插件播放 autoplay muted  -->
    <div class="videoGroup">
        <video :id="flvId" muted playsinline webkit-playsinline ref="player"
        class="video-js vjs-default-skin flvVideo" autoplay controls
        @timeupdate="updateProgress"></video>
    </div>
    <!-- <div class="progress-bar" v-if="flvId === 'history'">
        <div class="progress" :style="{ width: progress + '%' }"></div>
    </div> -->
    <div class="progressDiv" v-if="flvId === 'history'">
        <div class="dot" :style="{ left: dotPosition + '%' }" 
            @mousedown="startDrag"
            @mouseleave="isDragging = false"
        ></div>
        <el-progress ref="progress" :percentage="progress" :show-text="false" :stroke-width="12"/>
        <div>
            {{ formatTime(this.backTime) }} / {{ formatTime(this.time) }}
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import debounce from 'lodash/debounce';
import flvjs from 'flv.js'
export default {
    name: 'flvjsPlayer',
    // components:{
    //     VideoTitle
    // },
    props:{
        flvInfo:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        url:{type: String, default: ''},
        flvId:{type: String, default: ''},
        time: {type: Number, default: 0},
    },
    data(){
        return {
            flvPlayer: null,
            changeLampPost: false,
            progress: 0,
            videoLength: 0,
            dotPosition: 0,
            isDragging: false,
            startX: 0,
            backTime: null,
        }
    },
    created(){},
    mounted(){
        // this.init();
        this.$nextTick(() => {
            this.init();
        })
    },
    methods:{
        init(){
            let _this = this;
            if(_this.flvPlayer){
                _this.flvPlayer.pause();
                _this.flvPlayer.destroy();
                _this.flvPlayer = null;
            }else{
                if (flvjs.isSupported()) {
                    var videoEE = document.getElementById(_this.flvId);
                    var flvPlayer = flvjs.createPlayer(
                        {
                            type: 'flv',
                            isLive: true,
                            url: _this.url
                        },
                        {
                            enableWorker: false, //不启用分离线程
                            enableStashBuffer: false, //关闭IO隐藏缓冲区
                            reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
                            autoCleanupSourceBuffer: true //自动清除缓存
                        }
                    );
                    flvPlayer.attachMediaElement(videoEE);
                    flvPlayer.load();
                    flvPlayer.play();

                    _this.flvPlayer = flvPlayer
                }
            }
        },
        // updateProgress(){
        //     if(this.flvId === 'history' && !this.isDragging){
        //         const video = document.getElementById(this.flvId);
        //         this.progress = (video.currentTime / this.time) * 100;
        //         console.log("updateProgress"+this.progress)
        //     }
        // },
        updateProgress: _.throttle(function(){
            if(this.flvId === 'history' && !this.isDragging){
                const video = document.getElementById(this.flvId);
                this.progress = (video.currentTime / this.time) * 100;
                console.log(video.currentTime)
            }
        },100),
        destroyVideo(){
            this.flvPlayer.destroy();
            this.flvPlayer= null;
        },
        startDrag(event) {
            // event.preventDefault(); 
            this.isDragging = true;
            this.startX = event.clientX; // 记录鼠标按下时的位置
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.stopDrag);
            this.handleDrag(event);
        },
        handleDrag(event){
            if (this.isDragging) {
                const moveX = event.clientX - this.startX; // 计算移动距离
                // const moveX = event.clientX - this.$refs.dotDiv.left; // 计算移动距离
                const maxWidth = this.$refs.progress.width - 20;
                let newPosition = Math.max(0, Math.min(100, (this.dotPosition + (moveX / maxWidth) * 100))); 
                // const newPercentage = (moveX / maxWidth) * 100; // 计算新的百分比值
                // let newPosition = Math.max(0, Math.min(100, newPercentage));
                this.progress = newPosition;
                this.dotPosition = newPosition;
                this.backTime = this.time * (this.progress / 100)
                this.startX = event.clientX;
            }
        },
        stopDrag() {
            if(this.backTime){
                let time = Math.floor(this.backTime);
                this.$emit('timeClick', time)
                // this.player.pause()
                this.$refs.player.currentTime = this.backTime;
                const video = document.getElementById(this.flvId);
                // video.currentTime = this.backTime
                // this.player.play()
                
                console.log("1111111111")
                console.log(this.backTime)
                console.log(video.currentTime)
                console.log("3333333333")
            }
            this.isDragging = false;
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        },
    },
    beforeDestroy() {
        if (this.flvPlayer) {
            this.flvPlayer.destroy();
            this.flvPlayer = null;
        }
    },
    destroyed(){
        let _this = this
        setTimeout(() => {
            _this.flvPlayer.pause()
            _this.flvPlayer.destroy()
            _this.changeLampPost = true; // 这里视频做了优化处理 
        },500)
    },
    watch:{
        changeLampPost: {
            handler(newVal){
                if (newVal) {
                    this.$nextTick(() => {
                        this.destroyVideo();
                    })
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="less" scoped>
.videoGroup{
    width:100%;
    height:100%;
    position:relative;
    overflow: hidden;
}

.flv_box{
    width: 100%;
    height: calc(100vh - 30px);
}
.flvVideo{  //视频撑满
    background-color: #000;
    width:100%;
    height:100%;
    object-fit: fill;
}
.progress-bar {
    margin-top: 15px;
    width: 100%;
    height: 8px;
    background: rgba(204, 204, 204, 0.6);
    border-radius: 6px;
}
.progress {
    height: 100%;
    background: #007bff;
    transition: width 0.1s;
}

.progressDiv{
    margin: 10px 0;
    position: relative;
    width: 100%;
}
.dot {
    width: 20px;
    height: 20px;
    background-color: #409EFF;
    border-radius: 50%;
    position: absolute;
    top: -5px;
    cursor: pointer;
    transform: translateX(-50%);
    z-index: 99;
}
.dot:hover {
    transform: translateX(-50%) scale(1.2);
}

.dot.active {
    background-color: #409eff;
    transform: translateX(-50%) scale(1.3);
}
</style>
